export default __webpack_public_path__ + "images/070f0e1d49a2ddc4da26bebd508e0802.png";